import { useParams } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { Search } from 'lucide-react';
import { Layout } from '@/components/Layout';
import { ArticleCard } from '@/components/ArticleCard';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useWikiSearch } from '@/hooks/useWikiSearch';
import NotFound from '@/pages/NotFound';

export function SearchPage() {
  const { query: rawQuery } = useParams<{ query: string }>();
  const query = rawQuery ? decodeURIComponent(rawQuery) : '';
  const { data: results, isLoading } = useWikiSearch(query);

  useSeoMeta({
    title: `Search: ${query} — Wikistar`,
  });

  if (!rawQuery) return <NotFound />;

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-4 py-8">
        <h1 className="mb-6 flex items-center gap-2 text-2xl font-bold tracking-tight">
          <Search className="size-6" />
          Results for "{query}"
        </h1>

        {isLoading ? (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-40 w-full" />
            ))}
          </div>
        ) : results && results.length > 0 ? (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {results.map((event) => (
              <ArticleCard key={event.id} event={event} />
            ))}
          </div>
        ) : (
          <Card className="border-dashed">
            <CardContent className="py-12 px-8 text-center">
              <p className="mx-auto max-w-sm text-muted-foreground">
                No articles matched your search. Try a different term, or write the article
                yourself!
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </Layout>
  );
}
